import { Settings, X, Sun, Moon } from 'lucide-react';

const cn = (...classes) => classes.filter(Boolean).join(' ');


export default function SettingsModal({ open, handleClose, darkMode, toggleDarkMode }) {
  if (!open) return null; 

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm z-50 flex items-center justify-center p-4 transition-opacity duration-300">
      <div className={cn(
        "modal-content w-full max-w-md rounded-xl shadow-2xl p-6 transform transition-all duration-300 scale-95 opacity-0 animate-modal-pop-in",
        darkMode ? "bg-gray-800 text-gray-100 border border-gray-700" : "bg-white text-gray-900"
      )}>
        <div className="flex justify-between items-center mb-5 pb-3 border-b dark:border-gray-700">
           <div className="flex items-center gap-2">
             <Settings size={22} className={darkMode ? "text-blue-400" : "text-blue-600"}/>
             <h2 className="text-xl font-semibold">Settings</h2>
           </div>
          <button onClick={handleClose} className="p-1.5 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-500 dark:text-gray-400">
            <X size={20} />
          </button>
        </div>
        <div className="space-y-4">
          <div className="flex items-center justify-between py-3 border-b border-gray-200 dark:border-gray-700">
            <div>
              <h3 className="font-medium">Appearance</h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">Toggle between light and dark theme</p>
            </div>
            <button
              onClick={toggleDarkMode}
              className={cn(
                "p-2 rounded-full transition-colors duration-200",
                 darkMode
                  ? "bg-yellow-400 text-gray-900 hover:bg-yellow-500"
                  : "bg-gray-700 text-yellow-300 hover:bg-gray-600"
              )}
              aria-label={darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
            >
              {darkMode ? <Sun size={20} /> : <Moon size={20} />}
            </button>
          </div>
           <div className="flex items-center justify-between py-3 border-b border-gray-200 dark:border-gray-700 opacity-60 cursor-not-allowed">
             <div>
               <h3 className="font-medium">Notification Settings</h3>
               <p className="text-sm text-gray-500 dark:text-gray-400">Manage alerts (Feature upcoming)</p>
             </div>
             <button className="px-3 py-1.5 rounded-md bg-gray-200 dark:bg-gray-700 text-sm font-medium text-gray-500 dark:text-gray-400" disabled>Configure</button>
           </div>
           <div className="flex items-center justify-between py-3 border-b border-gray-200 dark:border-gray-700 opacity-60 cursor-not-allowed">
             <div>
               <h3 className="font-medium">Data & Privacy</h3>
               <p className="text-sm text-gray-500 dark:text-gray-400">Review data usage (Feature upcoming)</p>
             </div>
             <button className="px-3 py-1.5 rounded-md bg-gray-200 dark:bg-gray-700 text-sm font-medium text-gray-500 dark:text-gray-400" disabled>Manage</button>
           </div>
          <div className="flex items-center justify-between py-3">
            <div>
              <h3 className="font-medium">Account</h3>

            </div>
          </div>
        </div>
        <button
          onClick={handleClose} 
          className={cn(
            "w-full mt-6 py-2.5 rounded-lg font-semibold text-sm tracking-wide transition-colors",
            "bg-blue-600 hover:bg-blue-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800"
          )}
        >
          Done
        </button>
      </div>
       <style>{`
        @keyframes modal-pop-in {
          from { transform: scale(0.95); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
        .animate-modal-pop-in {
          animation: modal-pop-in 0.2s ease-out forwards;
        }
      `}</style>
    </div>
  );
}
